// ============================================================
// VidyaTrack — tiny SEO hook (no dependencies)
// Sets <title>, description, canonical, robots and OG tags per page.
// ============================================================
import { useEffect } from "react";

const SITE   = "https://vidyatrack3.web.app";
const BRAND  = "VidyaTrack";

const setMeta = (attr, key, content) => {
  if (content == null) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", content);
};

const setLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) { el = document.createElement("link"); el.setAttribute("rel", rel); document.head.appendChild(el); }
  el.setAttribute("href", href);
};

/**
 * useSEO({ title, description, path, noindex })
 *  - title:       page title (brand appended automatically)
 *  - description: meta description
 *  - path:        canonical path, e.g. "/legal/about"
 *  - noindex:     true for private/app pages
 */
export default function useSEO({ title, description, path = "/", noindex = false } = {}) {
  useEffect(() => {
    const fullTitle = title ? `${title} | ${BRAND}` : "VidyaTrack — School Management System in Nepal";
    const url = `${SITE}${path}`;

    document.title = fullTitle;
    setMeta("name", "title", fullTitle);
    setMeta("property", "og:title", fullTitle);
    setMeta("name", "twitter:title", fullTitle);
    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
      setMeta("name", "twitter:description", description);
    }
    setLink("canonical", url);
    setMeta("property", "og:url", url);
    setMeta("name", "twitter:url", url);

    const robots = noindex
      ? "noindex, nofollow, noarchive"
      : "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1";
    setMeta("name", "robots", robots);
    setMeta("name", "googlebot", robots);
  }, [title, description, path, noindex]);
}
